import { render, staticRenderFns } from "./MassEmail.vue?vue&type=template&id=7554fbbf&scoped=true&"
import script from "./MassEmail.vue?vue&type=script&lang=js&"
export * from "./MassEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7554fbbf",
  null
  
)

export default component.exports